var exports = {
  "kL": "xe564cbfb--69a68a--container",
  "Kk": "xe564cbfb--69a68a--icon",
  "Qs": "xe564cbfb--69a68a--content",
};

module.exports = exports;
